import {
    UpdateVideoCloudFileRequest,
    UpdateVideoCloudFileRequestLanguages,
    UpdateVideoCloudFileRequestTechnicalDetails
} from "../../../../../../../../common/api/master-api/cloud-files/update/UpdateVideoCloudFileRequest";
import { isCleanVideoSubtitleLanguageId } from "../../../../../../../../common/api/master-api/common/consts";
import { EmbeddedSubtitleType } from "../../../../../../../../common/types/EmbeddedSubtitleType";
import {
    CloudFileAssociationLanguagesFormState,
    CloudFileAssociationVideoTechnicalDetailsFormState
} from "../../../context/CloudFileAssociationContext";
import { RequestBuilderParams } from "./RequestBuilderParams";

export const buildUpdateVideoCloudFileRequest = ({
    cloudFileId,
    contentRef,
    selectedLanguages,
    selectedVideoTechnicalDetails
}: RequestBuilderParams): UpdateVideoCloudFileRequest => {
    const languages = mapLanguages(selectedLanguages);

    const technicalDetails = mapTechnicalDetails(selectedVideoTechnicalDetails);

    return {
        cloudFileId,
        contentDetails: contentRef,
        languages,
        technicalDetails
    };
};

const mapLanguages = (selection: CloudFileAssociationLanguagesFormState) => {
    const languages: UpdateVideoCloudFileRequestLanguages = {};

    if (selection.soundtrackLanguageId) languages.soundtrackLanguageId = selection.soundtrackLanguageId;

    if (selection.subtitleLanguageId) {
        if (isCleanVideoSubtitleLanguageId(selection.subtitleLanguageId)) {
            languages.subtitleLanguage = {
                type: EmbeddedSubtitleType.CleanVideo
            };
        } else {
            languages.subtitleLanguage = {
                type: EmbeddedSubtitleType.Subtitle,
                id: selection.subtitleLanguageId
            };
        }
    }

    return languages;
};

const mapTechnicalDetails = ({ aspectRatioId, aspectTypeId }: CloudFileAssociationVideoTechnicalDetailsFormState) => {
    const technicalDetails: UpdateVideoCloudFileRequestTechnicalDetails = {};

    if (aspectRatioId) technicalDetails.aspectRatioId = aspectRatioId;

    if (aspectTypeId) technicalDetails.aspectTypeId = aspectTypeId;

    return technicalDetails;
};
